import { Link } from "react-router-dom";
import SiteLayout from "@/components/site/SiteLayout";
import PageHero from "@/components/site/PageHero";
import { Check } from "lucide-react";
import { useI18n } from "@/lib/i18n";

export default function DlaKliniki() {
  const { t, path } = useI18n();

  return (
    <SiteLayout>
      <PageHero eyebrow={t.clinic.eyebrow} title={t.clinic.title} description={t.clinic.description} />

      <section className="py-16 lg:py-20 border-b border-border">
        <div className="mx-auto max-w-container px-6 lg:px-10">
          <div className="max-w-5xl mb-10 reveal">
            <div className="text-xs uppercase tracking-[0.18em] text-muted-foreground mb-4">
              {t.clinic.benefitsEyebrow}
            </div>
            <h2 className="font-serif text-[36px] lg:text-[48px] leading-[1.1] tracking-tight">
              {t.clinic.benefitsTitle}
            </h2>
          </div>
          <div className="grid md:grid-cols-2 gap-x-12 gap-y-10">
            {t.clinic.benefits.map(([title, body]) => (
              <div key={title} className="reveal">
                <Check className="h-5 w-5 text-primary mb-3" strokeWidth={1.5} />
                <h3 className="font-serif text-2xl mb-2">{title}</h3>
                <p className="text-muted-foreground leading-relaxed">{body}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="py-16 lg:py-20 bg-secondary border-b border-border">
        <div className="mx-auto max-w-container px-6 lg:px-10">
          <div className="max-w-2xl mb-10 reveal">
            <div className="text-xs uppercase tracking-[0.18em] text-muted-foreground mb-4">
              {t.clinic.processEyebrow}
            </div>
            <h2 className="font-serif text-[36px] lg:text-[48px] leading-[1.1] tracking-tight">
              {t.clinic.processTitle}
            </h2>
          </div>
          <div className="grid md:grid-cols-2 gap-8 lg:gap-10">
            {t.clinic.process.map(([n, title, body]) => (
              <div key={n} className="reveal border-t border-border pt-6">
                <div className="font-serif text-xl text-muted-foreground mb-3">{n}</div>
                <h3 className="font-serif text-2xl mb-2">{title}</h3>
                <p className="text-muted-foreground leading-relaxed">{body}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="py-16 lg:py-20 border-b border-border">
        <div className="mx-auto max-w-container px-6 lg:px-10">
          <div className="max-w-2xl mb-10 reveal">
            <div className="text-xs uppercase tracking-[0.18em] text-muted-foreground mb-4">
              {t.clinic.slaEyebrow}
            </div>
            <h2 className="font-serif text-[36px] lg:text-[48px] leading-[1.1] tracking-tight">
              {t.clinic.slaTitle}
            </h2>
          </div>
          <div className="grid sm:grid-cols-2 lg:grid-cols-4 border-t border-border">
            {t.clinic.sla.map(([value, label]) => (
              <div key={label} className="border-b sm:border-r border-border last:border-r-0 py-8 px-6 reveal text-center">
                <div className="font-serif text-4xl lg:text-5xl tracking-tight mb-3">{value}</div>
                <div className="text-sm text-muted-foreground">{label}</div>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="py-16 lg:py-20">
        <div className="mx-auto max-w-container px-6 lg:px-10">
          <div className="max-w-3xl reveal">
            <h2 className="font-serif text-[36px] lg:text-[52px] leading-[1.05] tracking-tight">
              {t.clinic.ctaTitle}
            </h2>
            <p className="mt-4 text-lg text-muted-foreground leading-relaxed">{t.clinic.ctaBody}</p>
            <Link
              to={path("contact")}
              className="mt-7 inline-flex items-center rounded-md bg-primary px-7 py-3.5 text-sm font-medium text-primary-foreground hover:bg-primary/90 transition-colors"
            >
              {t.nav.demo}
            </Link>
          </div>
        </div>
      </section>
    </SiteLayout>
  );
}
